import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  // eslint-disable-next-line react/require-default-props
  variant?: 'primary' | 'secondary' | 'link';
  // eslint-disable-next-line react/require-default-props
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  fullWidth = true,
  className = '',
  children,
  ...props
}) => {
  const baseClasses =
    'py-3 rounded-lg font-semibold transition-opacity disabled:opacity-50 disabled:cursor-not-allowed';
  const widthClass = fullWidth ? 'w-full' : '';

  const variantClasses = {
    primary:
      'bg-gradient-to-r from-[#8510DF] to-[#3D9CFB] text-white hover:opacity-90',
    secondary: 'bg-gray-800 text-white hover:bg-gray-700',
    link: 'text-gray-600 hover:text-gray-800 text-sm bg-transparent',
  };

  return (
    <button
      className={`${baseClasses} ${widthClass} ${variantClasses[variant]} ${className}`}
      type="button"
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
